import { updateAnalyticsTaskAttribute } from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticTaskAttributeProps = {
    attribute?: string;
}

export const changeAnalyticsTaskAttribute = ({
    attribute,
}: AnalyticTaskAttributeProps) => updateAnalyticsTaskAttribute({
    attribute,
});
